import { render, staticRenderFns } from "./AppDepartmentTripleCardsBlock.vue?vue&type=template&id=6d37e6d4"
import script from "./AppDepartmentTripleCardsBlock.vue?vue&type=script&lang=js"
export * from "./AppDepartmentTripleCardsBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports